import { useCommunityPlanAddon } from "@circle-react/hooks/addons/useCommunityPlanAddon";
import { noop } from "lodash";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";

const ATTENDEE_SEATS_ADDON_SLUG = "live_stream_spectators";

export const useAttendeeSeatsAddon = (options = { enabled: true }) => {
  const { error } = useToast();
  const onPurchaseError = () =>
    error(t("live_streams.room.attendees_addon_quantity_error"));
  return useCommunityPlanAddon(
    ATTENDEE_SEATS_ADDON_SLUG,
    onPurchaseError,
    noop,
    options,
  );
};
